export interface IWarehouseListItem {
  id: string;
  storeId: string;
  name: string;
  address: string;
  schedule: number[];
  status: WarehouseStatuses;
  serviceHours: ServiceHours;
  etaBufferTime: number;
  deliverooSiteStatus: DeliverooSiteStatus | null;
  jahezSiteStatus: JahezSiteStatus | null;
}

export enum WarehouseStatuses {
  Active = 0,
  Busy = 1,
  Inactive = 2
}

export enum AreaStatuses {
  Active = 0,
  Busy = 1,
  Inactive = 2,
  AutoBusy = 3
}

export enum DeliverooSiteStatus {
  Open = 0,
  Closed = 1,
  ReadyToOpen = 2
}

export enum JahezSiteStatus {
  Open = 0,
  Closed = 1
}

export interface ServiceHours {
  startTime: string;
  endTime: string;
}

export interface IWarehouseDetails {
  id: string;
  shopifyId: string;
  name: string;
  serviceHoursStartTime: string;
  serviceHoursEndTime: string;
  serviceDays: number[];
  status: WarehouseStatuses;
  busyMessageEnglish: string;
  busyMessageArabic: string;
  delayWarningMessageEn: string;
  delayWarningMessageAr: string;
  etaBufferTime: number;
}

export interface IDeliverooTimeRange {
  id: string;
  startTime: string;
  endTime: string;
}

export interface IDeliverooServiceHours {
  enabled: boolean;
  timeRanges: IDeliverooTimeRange[];
}

export interface IStoreDeliverooDetails {
  id: string;
  deliverooSiteId: string | null;
  deliverooSiteStatus: DeliverooSiteStatus | null;
  deliverooServiceHours: {
    monday: IDeliverooServiceHours;
    tuesday: IDeliverooServiceHours;
    wednesday: IDeliverooServiceHours;
    thursday: IDeliverooServiceHours;
    friday: IDeliverooServiceHours;
    saturday: IDeliverooServiceHours;
    sunday: IDeliverooServiceHours;
  };
}

export interface IStoreDeliveroServiceHoursDetails {
  id: string;
  deliverooServiceHours: {
    monday: IDeliverooServiceHours;
    tuesday: IDeliverooServiceHours;
    wednesday: IDeliverooServiceHours;
    thursday: IDeliverooServiceHours;
    friday: IDeliverooServiceHours;
    saturday: IDeliverooServiceHours;
    sunday: IDeliverooServiceHours;
  };
}

export interface IStoreDeliveroServiceStatus {
  id: string;
  deliverooSiteStatus: DeliverooSiteStatus;
}

export interface IDeliverooSiteSettings {
  id: string;
  deliverooSiteId: string | null;
}

export interface IStoreJahezDetails {
  id: string;
  status: boolean;
}
